import {createI18n} from 'vue-i18n';
import {messagesFromGlob} from '../../../../i18n-glob.js';

function loadLocaleMessages() {
  return messagesFromGlob(
    import.meta.glob('../locales/**/*.json', {eager: true})
  );
}

const europeDateFormat = {
  longSeconds: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  short: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
};

const datetimeFormats = {
  'fr-BE': europeDateFormat,
};

export const i18n = createI18n({
  legacy: false,
  locale: 'fr-BE',
  fallbackLocale: 'fr-BE',
  datetimeFormats,
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
});

export const translate = (key, payload = null) => {
  return i18n.global.t(key, payload);
};

export default i18n;
